import { currentDate } from "./features/current-date";
import { visitorCountry, fillCountryFields } from "./features/visitor-country";
import { phoneInput } from "./features/phone-input";
import { formValidation } from "./features/form-validation";
import { emailCheck } from "./features/email-check";
import { submitFlow } from "./features/submit-flow";
import { entryFlow } from "./features/entry-flow";
import { pageViewPixel } from "./features/page-view-pixel";
import { attributionCookie } from "./features/attribution-cookie";
import { viewContentPixel } from "./features/view-content-pixel";
import { initiateCheckoutPixel } from "./features/initiate-checkout-pixel";
import { purchasePixel } from "./features/purchase-pixel";
import { stateList } from "./features/state-list";
import { countrySelect } from "./features/country-select";
import { pincodeAutofill } from "./features/pincode-autofill";
import { networkProbe } from "./features/network-probe";
import { firePixel, firePixelAndWait } from "./pixels";

const features = {
	currentDate,
	visitorCountry,
	phoneInput,
	formValidation,
	submitFlow,
	entryFlow,
	pageViewPixel,
	viewContentPixel,
	initiateCheckoutPixel,
	purchasePixel,
	stateList,
	countrySelect,
	pincodeAutofill,
};

window.FunnelsSDK = {
	has(name) {
		return Object.prototype.hasOwnProperty.call(features, name);
	},
	visitorCountry,
	firePixel,
	firePixelAndWait,
};

//Transitional bridge: landings historically call these globals, provided
//until now by thank-you-pixel.js / pixel-lite.js. Where those files still
//load they win - body scripts run before this deferred bundle - so pages
//migrate by simply dropping their pixel-helper tag.
if (!window._getPixel) {
	window._getPixel = firePixel;
}
if (!window._getPixelAndWait) {
	window._getPixelAndWait = firePixelAndWait;
}

//The one call that must not wait for the DOM. It is the CRM's only signal
//that a click turned into a rendered page, and the visitor it measures is the
//one most likely to be gone in a second: the React indexes carry ~270 KB of
//HTML behind a chunk waterfall, so their DOMContentLoaded lands seconds after
//the document did, and firing there lost half of them - the pixel-lite loader
//this library replaced fired on its own load event and measured 64% of the
//clicks where boot() measures 42%. It needs no markup, so it goes out the
//moment this script runs, which on those pages is from the head, before
//<body> exists - pixels.js holds the injection, not the request.
pageViewPixel();
attributionCookie();
networkProbe();

function boot() {
	entryFlow();
	viewContentPixel();
	initiateCheckoutPixel();
	purchasePixel();
	stateList();
	pincodeAutofill();
	currentDate();
	fillCountryFields();
	phoneInput();
	formValidation();
	emailCheck();
	submitFlow();
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
